import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

interface OfferProcessingState {
  processingOfferUuid: string | null;
}

const initialState: OfferProcessingState = {
  processingOfferUuid: null,
};

export const offerProcessingSlice = createSlice({
  name: 'offerProcessing',
  initialState,
  reducers: {
    setProcessingOfferUuid: (state, action: PayloadAction<string | null>) => {
      state.processingOfferUuid = action.payload;
    },
    clearProcessingOfferUuid: (state) => {
      state.processingOfferUuid = null;
    },
  },
});

export const { setProcessingOfferUuid, clearProcessingOfferUuid } = offerProcessingSlice.actions;
